import { translate } from 'store/modules/base/i18n/functions';
import AbstractButton from './AbstractButton';
import { connect } from 'store/modules/base/redux/functions';
import { sendMultiKnockMessage } from 'store/modules/chat';
import { Knock } from 'assets/images';

/**
 * Implements an {@link AbstractButton} to open the user documentation in a new window.
 */
class KnockThemButton extends AbstractButton {
  accessibilityLabel = 'toolbar.accessibilityLabel.knock';
  icon = Knock;
  label = 'toolbar.knockThem';
  type = 'orange';

  // tooltip = 'toolbar.knockThem';

  /**
   * Handles clicking / pressing the button, and opens a new window with the user documentation.
   *
   * @private
   * @returns {void}
   */
  _handleClick() {
    this.props.dispatch(sendMultiKnockMessage());
  }
}

/**
 * Maps part of the redux state to the component's props.
 *
 * @param {Object} state - The redux store/state.
 * @returns {Object}
 */
function _mapStateToProps() {
  // const enabled = getFeatureFlag(state, HELP_BUTTON_ENABLED, true);
  // const visible = typeof userDocumentationURL === 'string' && enabled;

  return {
    visible: true
  };
}

export default translate(connect(_mapStateToProps)(KnockThemButton));
